import React, { useMemo } from 'react';
import styled, { withTheme } from 'styled-components';
import Select, { components } from 'react-select';
import { Icon } from 'components/atoms';
import { lighten } from 'polished';
import { themeType } from 'types';

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <Icon icon="search" />
  </components.DropdownIndicator>
);

const SearchBar = ({ theme }) => {
  const selectTheme = useMemo(
    () => ({
      danger: theme.colors.danger,
      dangerLight: theme.colors.dangerLighter,
      neutral0: 'hsl(0, 0%, 100%)',
      neutral5: 'hsl(0, 0%, 95%)',
      neutral10: 'hsl(0, 0%, 90%)',
      neutral20: 'hsl(0, 0%, 80%)',
      neutral30: 'hsl(0, 0%, 70%)',
      neutral40: 'hsl(0, 0%, 60%)',
      neutral50: 'hsl(0, 0%, 50%)',
      neutral60: 'hsl(0, 0%, 40%)',
      neutral70: 'hsl(0, 0%, 30%)',
      neutral80: 'hsl(0, 0%, 20%)',
      neutral90: 'hsl(0, 0%, 10%)',
      primary: theme.colors.primary,
      primary25: lighten(0.6, theme.colors.primary),
      primary50: lighten(0.3, theme.colors.primary),
      primary75: theme.colors.primaryDarker,
    }),
    [theme]
  );
  return (
    <Wrapper>
      <Select
        components={{ DropdownIndicator }}
        theme={{ colors: selectTheme }}
        placeholder="Search pages"
      />
    </Wrapper>
  );
};

SearchBar.propTypes = {
  theme: themeType.isRequired,
};

const Wrapper = styled.div`
  max-width: 400px;
`;

export default withTheme(SearchBar);
